import { render } from "./PartnerListTr.vue?vue&type=template&id=cffdbf66&scoped=true"
import script from "./PartnerListTr.vue?vue&type=script&lang=js"
export * from "./PartnerListTr.vue?vue&type=script&lang=js"

import "@/styles/table.css?vue&type=style&index=0&lang=css"
import "@/styles/striNew.css?vue&type=style&index=1&lang=css"
import "./PartnerListTr.vue?vue&type=style&index=2&id=cffdbf66&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/tcd-partnerpage-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cffdbf66"]])

export default __exports__